/*
 * @Author: changcheng
 * @LastEditTime: 2023-10-10 11:13:13
 */
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@root/store/index";
import moment from "moment";
import {
  updateUserInfo,
  getUserInfoByUserId,
  getInstituteList,
} from "@root/common/service";
import { UserDetailInfoProps } from "@root/actions/index";
import { setUserInfo } from "@root/reducers/user";
import "./_style.scss";
import {
  Button,
  Space,
  Form,
  DatePicker,
  Input,
  Select,
  message,
  TreeSelect,
} from "antd";
import { subjectDic } from "@root/common/data/dic";
import { useEffect } from "react";
import { validatorIdCard, queryInstituteList } from "@root/common/utils";
const { Option } = Select;
const baseAuditStatusArr = ["通过", "审核退回", "未确认"];
export default function BaseInformation() {
  const dispatch = useDispatch();
  const {
    instituteList = [],
    subjectData,
    titleData,
  } = useSelector((state: RootState) => state.directionaries);
  const rootStateUserInfo = useSelector((state: RootState) => state.userInfo);
  const { userDetailInfo, access_token } = rootStateUserInfo;
  const { centerClassification = [] } = useSelector(
    (state: RootState) => state.directionaries
  );
  useEffect(() => {
    getInstituteList((userDetailInfo as any).instituteId);
  }, [userDetailInfo]);
  /**
   * 计算哪些基本信息修改了
   * @param userInfo 修改的信息
   * @returns
   */
  const diffUserInfo = (userInfo: UserDetailInfoProps) => {
    console.log("userInfo", userInfo);

    let uploadParam = {};
    let keys = Object.keys(userInfo);
    for (let val of keys) {
      if (val === "centerCategoryList") {
        if (
          // @ts-ignore
          String(userInfo[val]) !==
          String(userDetailInfo?.baseCenterCategoryList)
        ) {
          // @ts-ignore
          uploadParam[val] = userInfo[val];
        }
        // @ts-ignore
      } else if (String(userInfo[val]) !== String(userDetailInfo[val])) {
        // @ts-ignore
        uploadParam[val] = userInfo[val];
      }
    }
    return uploadParam as UserDetailInfoProps;
  };
  /**
   * 更新用户审核状态和信息
   */
  const updateBaseInfo = async () => {
    const { data = [] } = await getUserInfoByUserId(userId);
    const userInfo = data[0];
    userInfo.baseCenterCategoryList.map((item: number) => Number(item));
    dispatch(
      setUserInfo({
        ...rootStateUserInfo,
        access_token,
        userDetailInfo: userInfo,
      })
    );
  };
  useEffect(() => {
    updateBaseInfo();
  }, []);
  // 更新用户信息
  const updateUserInfoFinish = async (values: UserDetailInfoProps) => {
    const { identityNumber, baseUserIdCategory } = values;
    if (baseUserIdCategory === "0" && !validatorIdCard(identityNumber)) {
      message.info("身份证号码不符合规则");
      return;
    }
    // 处理出生日期
    // @ts-ignore
    values.birthday = values.birthday._i;
    const diffValues = diffUserInfo(values);
    await updateUserInfo({ ...diffValues, userId });
    await getUserInfoByUserId(userId);
    message.success("修改成功");
    const { data = [] } = await getUserInfoByUserId(userId);
    dispatch(
      setUserInfo({
        ...rootStateUserInfo,
        access_token,
        userDetailInfo: data[0],
      })
    );
  };
  const { baseAuditStatus, userId } = userDetailInfo as any;
  return (
    <div className="BaseInformation">
      <div>
        {/* <h2>审核状态</h2> */}
        {/* <div>
          {status === "4" ? (
            <p>
              {flowType === "2" ? (
                <Button type="primary">
                  {baseAuditStatusArr[Number(baseAuditStatus)]}
                </Button>
              ) : (
                <Button type="primary">调出</Button>
              )}
            </p>
          ) : (
            <Space>
              {baseAuditStatus === "2" && (
                <Button type="primary">待审核</Button>
              )}
              {baseAuditStatus === "0" && (
                <Button type="primary">审核通过</Button>
              )}
              {baseAuditStatus === "1" && (
                <Button type="primary">退回修改</Button>
              )}
              {!baseAuditStatus && <Button type="primary">审核通过</Button>}
            </Space>
          )}
        </div> */}
        <div className="updateInfo_container">
          <div>
            <h2>基本信息</h2>
            <span style={{ color: "red" }}>提示：基本信息完善暂未开放。</span>
            <Form
              initialValues={{
                ...userDetailInfo,
                birthday: moment(userDetailInfo?.birthday, "YYYY-MM-DD"),
                centerCategoryList: Array.isArray(
                  userDetailInfo?.baseCenterCategoryList
                )
                  ? userDetailInfo?.baseCenterCategoryList.map((item) =>
                      Number(item)
                    )
                  : [],
              }}
              onFinish={updateUserInfoFinish}
              disabled={true}
              style={{
                marginTop: "10px",
              }}
            >
              <Form.Item
                name="birthday"
                label="出生日期"
                rules={[{ required: true, message: "请选择出生日期" }]}
              >
                <DatePicker />
              </Form.Item>
              <Form.Item
                name="nickName"
                label="姓名"
                rules={[{ required: true, message: "请输入姓名" }]}
              >
                <Input placeholder="请输入姓名" />
              </Form.Item>
              <Form.Item
                name="sex"
                label="性别"
                rules={[{ required: true, message: "请选择您的性别" }]}
              >
                <Select>
                  <Option value="0">男</Option>
                  <Option value="1">女</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="baseHealthTitle"
                label="职称"
                rules={[{ required: true, message: "请选择专业技术职称" }]}
              >
                <Select style={{ width: "260px" }}>
                  <Option value="">请选择专业技术职称</Option>
                  {titleData.map((item, index) => (
                    <Option value={item.id} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="subjectId"
                label="学科"
                rules={[{ required: true, message: "请选择所在学科" }]}
              >
                <TreeSelect
                  showSearch
                  style={{ width: "100%" }}
                  treeData={subjectDic}
                  dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                  placeholder="请选择所在学科"
                />
              </Form.Item>
              <Form.Item
                name="phonenumber"
                label="手机号"
                rules={[{ required: true, message: "请输入手机号" }]}
              >
                <Input placeholder="请输入11位手机号" disabled={true} />
              </Form.Item>
              <Form.Item
                name="baseUserIdCategory"
                label="证件类型"
                rules={[{ required: true, message: "请选择证件类型" }]}
              >
                <Select disabled={baseAuditStatus === "0"}>
                  <Option value="0">身份证</Option>
                  <Option value="1">其他</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="identityNumber"
                label="身份证号码"
                rules={[{ required: true, message: "请输入身份证号码" }]}
              >
                <Input
                  placeholder="请输入身份证号码"
                  disabled={baseAuditStatus === "0"}
                />
              </Form.Item>
              <Form.Item
                name="instituteId"
                label="机构名称"
                rules={[{ required: true, message: "请选择机构" }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  onSearch={(val) => {
                    queryInstituteList(val);
                  }}
                >
                  <Option value="">请选择机构</Option>
                  {instituteList.map((item, index) => (
                    <Option value={item.id} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="centerCategoryList"
                label="所在中心"
                rules={[{ required: true, message: "请选择所在中心" }]}
              >
                <Select placeholder="请选择所在中心" mode="multiple">
                  {centerClassification.map((it) => (
                    <Option value={it.id}>{it.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Space>
                  <Button type="primary" htmlType="submit">
                    修改
                  </Button>
                </Space>
              </Form.Item> */}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
